// document.addEventListener('DOMContentLoaded', function () {
//   var popup = document.getElementById('custom-page-popup');
//   var closeBtn = document.getElementById('custom-popup-close');
//   var popupLink = document.getElementById('custom-popup');
//   if (!popup) return;
//   var SESSION_KEY = 'popup_session_state';
//   var SUPPRESSION_KEY = 'popup_suppressed_until';
//   var currentPath = window.location.pathname.toLowerCase();
//   if (
//     currentPath === '/cart' ||
//     currentPath.indexOf('/cart/') === 0 ||
//     currentPath.indexOf('/checkout') === 0
//   ) {
//     return;
//   }
//   function getState() {
//     try {
//       return JSON.parse(
//         sessionStorage.getItem(SESSION_KEY)
//       ) || {
//         pageviews: 0,
//         quizShown: false,
//         quizCompleted: false,
//         quizDismissed: false,
//         emailShown: false
//       };

//     } catch (e) {
//       return {
//         pageviews: 0,
//         quizShown: false,
//         quizCompleted: false,
//         quizDismissed: false,
//         emailShown: false
//       };
//     }
//   }
//   function saveState(state) {
//     sessionStorage.setItem(
//       SESSION_KEY,
//       JSON.stringify(state)
//     );

//   }
//   function isSuppressed() {
//     var until = parseInt(
//       localStorage.getItem(SUPPRESSION_KEY) || '0',
//       10
//     );
//     return Date.now() < until;
//   }
//   function suppressFor7Days() {
//     var sevenDays =
//       7 * 24 * 60 * 60 * 1000;
//     localStorage.setItem(
//       SUPPRESSION_KEY,
//       String(Date.now() + sevenDays)
//     );
//   }
//   var state = getState();
//   state.pageviews++;
//   saveState(state);
//   if (state.pageviews === 1) {
//     return;
//   }
//   if (isSuppressed()) {
//     return;
//   }
//   function showQuiz() {
//     var state = getState();
//     if (state.emailShown) {
//       return;
//     }
//     if (state.quizCompleted) {
//       return;
//     }
//     if (isSuppressed()) {
//       return;
//     }
//     state.quizShown = true;
//     saveState(state);
//     popup.classList.add('active');
//   }
//   function hideQuiz() {
//     popup.classList.remove('active');
//     var state = getState();
//     state.quizDismissed = true;
//     saveState(state);
//   }
//   if (closeBtn) {
//     closeBtn.addEventListener('click', function (e) {
//       e.preventDefault();
//       hideQuiz();
//     });
//   }
//   popup.addEventListener('click', function (e) {
//     if (e.target === popup) {
//       hideQuiz();
//     }
//   });
//   if (popupLink) {
//     popupLink.addEventListener('click', function () {
//       popup.classList.remove('active');
//     });
//   }
//   window.customQuizSubmitted = function () {
//     var state = getState();
//     state.quizCompleted = true;
//     saveState(state);
//     suppressFor7Days();
//     popup.classList.remove('active');
//     hideKlaviyoPopup();
//   };
//   function getKlaviyoPopup() {
//     var form = document.querySelector(
//       '[data-testid="klaviyo-form-RSpYZZ"]'
//     );
//     if (!form) return null;
//     return form.closest(
//       '[role="dialog"][aria-modal="true"]'
//     );
//   }
//   function hideKlaviyoPopup() {
//     var klaviyoPopup = getKlaviyoPopup();
//     if (klaviyoPopup) {
//       klaviyoPopup.style.display = 'none';
//     }
//   }
//   function shouldBlockKlaviyo() {
//     var state = getState();
//     if (state.quizCompleted) {
//       return true;
//     }
//     if (isSuppressed()) {
//       return true;
//     }
//     return false;
//   }
//   var observer = new MutationObserver(function () {
//     var state = getState();
//     var klaviyoPopup = getKlaviyoPopup();
//     if (!klaviyoPopup) {
//       return;
//     }
//     if (shouldBlockKlaviyo()) {
//       hideKlaviyoPopup();
//       return;
//     }
//     if (
//       popup.classList.contains('active')
//     ) {
//       hideKlaviyoPopup();
//       return;
//     }
//     if (!state.emailShown) {
//       state.emailShown = true;
//       saveState(state);
//     }
//   });
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
//   setTimeout(function () {
//     var state = getState();
//     if (
//       state.pageviews >= 2 &&
//       !state.quizShown &&
//       !state.emailShown &&
//       !state.quizCompleted &&
//       !isSuppressed()
//     ) {
//       showQuiz();
//     }
//   }, 15000);
// });

document.addEventListener('DOMContentLoaded', function () {

  /*
   * ===================================================
   * CRITICAL GUARD: Agar ye script kisi wajah se
   * (duplicate <script> tag, app embed conflict, etc.)
   * do baar load/run ho jaye, to dusri baar turant
   * ruk jaye. Isse overlapping timers aur double
   * event listeners kabhi nahi banenge.
   * ===================================================
   */
  if (window.__popupFlowInitialized) {
    console.warn('Popup script already running — duplicate load blocked.');
    return;
  }
  window.__popupFlowInitialized = true;

  var popup = document.getElementById('custom-page-popup');
  var closeBtn = document.getElementById('custom-popup-close');
  var popupLink = document.getElementById('custom-popup');

  var SESSION_KEY = 'popup_session_state';
  var SUPPRESSION_KEY = 'popup_suppressed_until';
  var KLAVIYO_FORM_ID = 'RSpYZZ';

  var QUIZ_DELAY_MS = 15000;
  var SIGNIN_DELAY_MS = 30000;

  var currentPath = window.location.pathname.toLowerCase();
  var blockedPage =
    currentPath === '/' ||
    currentPath === '/cart' ||
    currentPath.indexOf('/cart/') === 0 ||
    currentPath.indexOf('/checkout') === 0;

  if (popup) {
    popup.classList.remove('active');
  }

  if (blockedPage) {
    return;
  }

  function getDefaultState() {
    return {
      quizShown: false,
      quizCompleted: false,
      quizDismissed: false,
      signInShown: false,
      /*
       * FIX: Absolute page-load timestamp sessionStorage me save karo.
       * setTimeout memory-based hota hai — agar script kahi bhi
       * dobara run ho, purana timer bhi zinda reh sakta hai.
       * Timestamp check isse immune hai.
       */
      pageLoadTime: Date.now()
    };
  }

  function getState() {
    try {
      var saved = sessionStorage.getItem(SESSION_KEY);
      var parsed = saved ? JSON.parse(saved) : null;
      if (!parsed || !parsed.pageLoadTime) {
        var fresh = getDefaultState();
        saveState(fresh);
        return fresh;
      }
      return parsed;
    } catch (e) {
      var fallback = getDefaultState();
      saveState(fallback);
      return fallback;
    }
  }

  function saveState(state) {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  // Is page load ka apna reference time (naya page = naya time)
  var pageLoadTime = Date.now();

  function isSuppressed() {
    var until = parseInt(localStorage.getItem(SUPPRESSION_KEY) || '0', 10);
    return Date.now() < until;
  }

  function suppressFor7Days() {
    var sevenDays = 7 * 24 * 60 * 60 * 1000;
    localStorage.setItem(SUPPRESSION_KEY, String(Date.now() + sevenDays));
  }

  function showQuiz() {
    if (!popup) return;
    var state = getState();
    if (state.quizCompleted) return;
    if (isSuppressed()) return;
    if (popup.classList.contains('active')) return; // already khula, dobara mat kholo
    state.quizShown = true;
    saveState(state);
    popup.classList.add('active');
  }

  function hideQuiz() {
    if (!popup) return;
    popup.classList.remove('active');
    var state = getState();
    state.quizDismissed = true;
    saveState(state);
    document.dispatchEvent(new Event('customQuizClosed'));
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      hideQuiz();
    });
  }

  if (popup) {
    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        hideQuiz();
      }
    });
  }

  if (popupLink) {
    popupLink.addEventListener('click', function () {
      popup.classList.remove('active');
      document.dispatchEvent(new Event('customQuizClosed'));
    });
  }

  window.customQuizSubmitted = function () {
    var state = getState();
    state.quizCompleted = true;
    saveState(state);
    suppressFor7Days();
    if (popup) {
      popup.classList.remove('active');
    }
  };

  var signInTriggered = false;

  /*
   * FIX: Time-check ab Date.now() - pageLoadTime se hota hai,
   * kisi bhi memory flag ke bharose nahi. Isse guarantee milti
   * hai ki 30 second se pehle Klaviyo kabhi nahi khulega —
   * chahe event kitni jaldi fire ho.
   */
  function has30SecondsPassed() {
    return (Date.now() - pageLoadTime) >= SIGNIN_DELAY_MS;
  }

  function openKlaviyoSignIn() {
    if (!has30SecondsPassed()) return;
    if (signInTriggered) return;

    var state = getState();
    if (state.quizCompleted) return;
    if (isSuppressed()) return;

    if (popup && popup.classList.contains('active')) {
      return;
    }

    if (
      typeof window.klaviyo === 'undefined' ||
      typeof window.klaviyo.openForm !== 'function'
    ) {
      setTimeout(openKlaviyoSignIn, 500);
      return;
    }

    signInTriggered = true;
    state.signInShown = true;
    saveState(state);
    window.klaviyo.openForm(KLAVIYO_FORM_ID);

    watchKlaviyoDismiss();
  }

  function watchKlaviyoDismiss() {
    var alreadyHandled = false;

    var checkInterval = setInterval(function () {
      var dialog = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');

      if (!dialog && !alreadyHandled) {
        alreadyHandled = true;
        clearInterval(checkInterval);

        var state = getState();
        if (!state.signInSubmitted) {
          suppressFor7Days();
        }
      }
    }, 500);

    setTimeout(function () {
      clearInterval(checkInterval);
    }, 300000);
  }

  var isMobile = window.matchMedia('(max-width: 767px)').matches;

  if (!isMobile) {
    document.documentElement.addEventListener('mouseleave', function (event) {
      if (!has30SecondsPassed()) return;
      if (signInTriggered) return;
      if (event.clientY <= 0) {
        openKlaviyoSignIn();
      }
    });
  }

  if (isMobile) {

    var mobilePollInterval = null;

    function pollAndTryOpen() {
      var state = getState();

      if (state.quizCompleted || isSuppressed() || signInTriggered) {
        if (mobilePollInterval) clearInterval(mobilePollInterval);
        return;
      }

      if (!has30SecondsPassed()) return; // time abhi poora nahi hua, kuch mat karo

      if (popup && popup.classList.contains('active')) {
        return; // quiz abhi khula hai, agli poll try karegi
      }

      openKlaviyoSignIn();

      if (signInTriggered && mobilePollInterval) {
        clearInterval(mobilePollInterval);
      }
    }

    // 30s ke baad se har 2s check karo (quiz close hone ka wait)
    setTimeout(function () {
      pollAndTryOpen();
      mobilePollInterval = setInterval(pollAndTryOpen, 2000);
    }, SIGNIN_DELAY_MS);

    // Quiz close hote hi turant recheck — lekin andar has30SecondsPassed()
    // gate hai, isliye time se pehle kabhi nahi khulega
    document.addEventListener('customQuizClosed', function () {
      pollAndTryOpen();
    });
  }

  window.addEventListener('klaviyoForms', function (event) {
    if (!event.detail) return;
    if (event.detail.formId === KLAVIYO_FORM_ID && event.detail.type === 'submit') {
      var state = getState();
      state.signInShown = true;
      state.signInSubmitted = true;
      saveState(state);
    }
  });

  /*
   * FIX: Quiz bhi ab Date.now() - pageLoadTime se time-gated hai,
   * setTimeout ke bharose akela nahi — extra safety.
   */
  var quizCheckInterval = setInterval(function () {
    if ((Date.now() - pageLoadTime) < QUIZ_DELAY_MS) return;

    clearInterval(quizCheckInterval);

    var state = getState();
    if (!state.quizShown && !state.quizCompleted && !isSuppressed()) {
      showQuiz();
    }
  }, 500);

});